/**
 * Create a custom non-existent category
 * @param name Display Name
 * @param slug Sorting key (or name.toLower() if not provided)
 * @param term_id
 * @returns
 */
export default function createCustomCategory(name, slug, term_id) {
    return {
        term_id: term_id !== null && term_id !== void 0 ? term_id : -1,
        name: name,
        slug: slug !== null && slug !== void 0 ? slug : name.toLowerCase()
    };
}
